<template>
  <q-toolbar class="borda">
    <q-toolbar-title
        style="margin-left: 0.8em; padding: 0.5em;"
    >
      <div class="row items-center" style="display: flex; align-items: center;">
        <img
            src="https://www.tecban.com.br/images/tecban-logo-mobile.png"
            style="width: 142px; height: 45px; margin-right: 21px;"
        />
        <span class="text-weight-medium text-red-14 q-ml-md" style="font-size: 1.15em;">
          Consulta Ocorrências Itaú
      </span>
      </div>


    </q-toolbar-title>

    <q-space />
    <span class="text-weight-regular q-mr-sm">{{
        nomeUsuario
      }}</span>
    <q-btn-dropdown
        rounded
        dropdown-icon="account_circle"
        no-wrap
        unelevated
        square
        fab-mini
        no-icon-animation
    >
      <q-list>
        <q-item clickable v-close-popup @click="logout()">
          <q-item-section avatar>
            <q-avatar icon="login" text-color="black" class="cursor-pointer" @click="logout()" />
          </q-item-section>
          <q-item-section>
            <q-item-label class="cursor-pointer" @click="logout()">Sair</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
  </q-toolbar>
</template>

<script>
import { LocalStorage } from 'quasar';
import { logout, refreshToken } from '../services/authentication';

export default {
  name: "TecBanHeader",
  data() {
    return {
      nomeUsuario: LocalStorage.getItem("user"),
    };
  },
  methods: {
    logout() {
      logout();
    },
    refreshToken(){
      refreshToken()
    }
  }
}
</script>
<style>

.borda {
  border-bottom: 1px solid gray !important;
  border-bottom-left-radius: 5px; /* Arredonda o canto inferior esquerdo */
  border-bottom-right-radius: 5px; /* Arredonda o canto inferior direito */
  background-color: white;
}



</style>